<template>
    <BtnFollow
        class="protected-auth"
        v-bind="$attrs"
        :loading="loading"
        @click="onClick"
    />
</template>

<script lang="ts">
import { followSet } from '@/api/backend/flashcard';
import BtnFollow from '@/components/BtnFollow';
import { defineComponent } from 'vue';

/**
 * Btn that toggles the follow state for a flashcard set.
 * As an api call is involved and not yet mockable, it might not behave proeprly in storybook.
 * @todo mock api call in stories file
 */
export default defineComponent({
    name: 'BtnFollowFlashcard',
    components: {
        BtnFollow,
    },
    inheritAttrs: false,
    props: {
        /**
         * The id of the flashcard set to be updated
         */
        setId: {
            type: Number,
            required: true,
        },
    },
    emits: ['update:active'],
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        onClick() {
            if (this.loading) return;
            this.loading = true;

            followSet(this.setId)
                .then((response) => {
                    /**
                     * emitted whenever the follow status changes
                     */
                    this.$emit('update:active', response.data.has_followed);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
});
</script>

<style lang="scss" scoped></style>
